import { BaccaratEvents } from '../core/events/baccarat.js';
import {
  validateBaccaratBetConfirmation,
  validateBaccaratBetsUpdate,
  validateBaccaratGameOver,
} from '../core/validation/baccarat.js';

import { BaseSDKService } from './BaseSDKService.js';

/**
 * Baccarat SDK service — drop-in replacement for `BaccaratAIService` (iframe lib).
 * Method shape + validation match the iframe class exactly. See
 * `BlackjackSDKService` JSDoc for the factory-switch pattern.
 */
export class BaccaratSDKService extends BaseSDKService {
  sendWelcome(): void {
    this.dispatch(BaccaratEvents.createWelcome());
  }

  sendPlaceBet(): void {
    this.dispatch(BaccaratEvents.createPlaceBet());
  }

  sendBetsUpdate(bets: BaccaratEvents.Bet[], totalBet: number): void {
    validateBaccaratBetsUpdate(bets, totalBet);
    this.dispatch(BaccaratEvents.createBetsUpdate(bets, totalBet));
  }

  sendBetConfirmation(bets: BaccaratEvents.Bet[], totalBet: number, roundId: string): void {
    validateBaccaratBetConfirmation(bets, totalBet, roundId);
    this.dispatch(BaccaratEvents.createBetConfirmation(bets, totalBet, roundId.trim()));
  }

  sendGameOver(
    playerHand: BaccaratEvents.Hand,
    bankerHand: BaccaratEvents.Hand,
    result: BaccaratEvents.Result,
    bets: BaccaratEvents.BetOutcome[],
    totalBet: number,
    totalWin: number,
    roundId: string,
  ): void {
    validateBaccaratGameOver({
      playerHand,
      bankerHand,
      result,
      bets,
      totalBet,
      totalWin,
      roundId,
    });
    this.dispatch(
      BaccaratEvents.createGameOver(
        playerHand,
        bankerHand,
        result,
        bets,
        totalBet,
        totalWin,
        roundId.trim(),
      ),
    );
  }

  sendBetTimerExpired(): void {
    this.dispatch(BaccaratEvents.createBetTimerExpired());
  }
}
